import React from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-header">
          <h3>Lit Fibre</h3>
          <h3>Internet done properly </h3>
        </div>
        <div className="footer-links">
          <div className="accordion uncollapsed">
            <span
              className="accordion-title"
              aria-label="Important stuff"
              title="Important stuff"
            >
              <p>Important stuff</p>
            </span>
            <div className="accordion-panel">
              <Link
                className="footer-links-inner"
                title="Privacy policy"
                to="/legal/privacy-policy/"
              >
                Privacy policy
              </Link>
              <Link
                className="footer-links-inner"
                title="Privacy policy"
                to="/legal/cookie-policy/"
              >
                Cookie policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
